// onboarding-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'onb.ui.alreadyLinked': 'This company is already linked to your user. Select it in the client selector instead of creating it again.',
  'onb.ui.personalNotConnected': 'Personal finance is not connected to the backend in this build.',
  'onb.ui.personalCreatedLinked': 'Personal finance has been created and the family is linked.',
  'onb.ui.personalCreatedInvitePending': 'Personal finance has been created, but the invitation must be accepted from the notification.',
  'onb.ui.personalCreated': 'Personal finance has been created',
  'onb.ui.personalCreateFailed': 'Could not create personal finance.',
  'onb.ui.orgNumberNineDigits': 'The organisation number must be 9 digits.',
  'onb.ui.alreadyExists': 'This company already exists in Plumme.',
  'onb.ui.createNotConnected': 'Create company is not connected to the backend.',
  'onb.ui.companyCreated': 'The company has been created',
  'onb.ui.companyCreateFailed': 'Could not create the company.',
  'onb.ui.chooseSubPersonal': 'Personal overview, family finances, goals and tax – no company required.',
  'onb.ui.chooseSubFirm': 'Create an accounting firm, accept client engagements, or start a new client company.',
  'onb.ui.leadVerify': 'Plumme verifies Norwegian organisation numbers against the Brønnøysund Register Centre and sets up access.',
  'onb.ui.step1Company': 'Step 1 · The company',
  'onb.ui.back': '← Back',
  'onb.ui.creating': 'Creating...',
  'onb.ui.createAndAccept': 'Create and accept',
  'onb.ui.createPersonal': 'Create Personal Finance',
  'onb.ui.createCompany': 'Create company',
  'onb.ui.getStarted': 'Get started',
  'onb.ui.next': 'Next',
});
